import React, { useState } from "react";
import { utils } from "../../utils";
import s from "./index.module.css";
import { QrCodeModal } from "../";
import {
  FaAngleUp,
  FaAngleDown,
  FaLocationDot,
  FaLink,
  FaQrcode,
  FaShare,
  FaStore,
} from "react-icons/fa6";

function handleOpenLocation(mapLink, address) {
  if (mapLink) {
    window.open(mapLink, "_blank", "noopener,noreferrer");
    return;
  }

  if (address) {
    const encodedAddress = encodeURIComponent(address);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsUrl, "_blank", "noopener,noreferrer");
    return;
  }

  alert("Location information is not available for this store.");
}

async function handleSharePage(storeName) {
  const shareData = {
    title: storeName ? `Check out ${storeName}` : document.title,
    text: storeName ? `Check out ${storeName}` : "Check out this store",
    url: window.location.href,
  };

  if (navigator.share) {
    try {
      await navigator.share(shareData);
      return true;
    } catch (err) {
      if (err.name !== "AbortError") {
        console.error("Share failed:", err);
      }
      return false;
    }
  }

  try {
    await navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard! You can now share it.");
    return true;
  } catch (err) {
    console.error("Copy to clipboard failed:", err);

    alert(`Share this link: ${window.location.href}`);
    return false;
  }
}

function LocationButton({ mapLink, address }) {
  const handleClick = () => {
    handleOpenLocation(mapLink, address);
  };

  return (
    <button
      onClick={handleClick}
      className={s.iconBtn}
      aria-label="Open location in Google Maps"
    >
      <FaLocationDot />
    </button>
  );
}

function ShareButton({ storeName }) {
  const handleClick = async () => {
    await handleSharePage(storeName);
  };

  return (
    <button
      onClick={handleClick}
      className={s.iconBtn}
      aria-label="Share store"
    >
      <FaShare />
    </button>
  );
}

function QrCodeButton({ config, data }) {
  const [show, setShow] = useState(false);
  const handleClick = () => {
    setShow(!show);
  };

  return (
    <>
      <button
        onClick={handleClick}
        className={s.iconBtn}
        aria-label="Show QR code"
      >
        <FaQrcode />
      </button>
      {
        show &&
        <QrCodeModal 
          data={data}
          config={config}
          toggleShow={setShow}
        />
      }
    </>
  );
}

export function Banner({ data, config }) {
  const [open, setOpen] = useState(false);
  const logoImage = data?.images?.[0] ? utils.getImageUrl(data.images[0]) : "";

  // Get full address string
  const getFullAddress = () => {
    const parts = [];
    if (data?.address) parts.push(data.address);
    if (data?.city) parts.push(data.city);
    if (data?.state) parts.push(data.state);
    if (data?.zipCode) parts.push(data.zipCode);

    return parts.join(", ");
  };

  return (
    <div className={s.banner}>
      <div className={s.logoContainer}>
        <div className={s.leftSection}>
          <div className={s.logo}>
            {logoImage ? (
              <img
                src={logoImage}
                alt={data?.name ? `${data.name} logo` : "Store logo"}
                className={s.logoImage}
              />
            ) : (
              <FaStore className={s.storeIcon} />
            )}
          </div>

          <div className={s.companyDetails}>
            <h1 className={s.title}>{data?.name || "Store Name"}</h1>
            <p className={s.tagline}>{data?.website || ""}</p>
            <div className={s.categoryRow}>
              <p className={s.category}>
                {data?.category || "Category"}
                <button
                  className={s.ShowBtn}
                  onClick={() => setOpen((prev) => !prev)}
                  aria-label={open ? "Hide details" : "Show details"}
                  aria-expanded={open}
                >
                  {open ? <FaAngleUp /> : <FaAngleDown />}
                </button>
              </p>
            </div>
          </div>
        </div>

        <div className={s.centerSpacer}></div>

        <div className={s.rightSection}>
          {/* <LocationButton mapLink={mapLink} address={getFullAddress()} /> */}
          <QrCodeButton config={config} data={data}/>
          <ShareButton storeName={data?.name} />
        </div>
      </div>

      {open && (
        <div className={s.extraDetails} aria-hidden={!open}>
          {data?.city && data?.state && (
            <div className={s.tag}>
              <FaLocationDot className={s.extraicon} />
              <span>
                {data.city}, {data.state}
                {data?.address && ` • ${data.address}`}
              </span>
            </div>
          )}

          {data?.website && (
            <div className={s.tag}>
              <FaLink className={s.extraicon} />
              <a
                href={
                  data.website.startsWith("http")
                    ? data.website
                    : `https://${data.website}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className={s.websiteLink}
              >
                {data.website}
              </a>
            </div>
          )}

          {data?.description && (
            <div className={s.descriptionContainer}>
              <h3 className={s.descriptiontitle}>
                About {data?.name || "this store"}
              </h3>
              <p className={s.Edescription}>{data.description}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
